//Komponenten
import BasePage from "../../components/layout/BasePage"
import HelloFilmAnimation from "./components/HelloFilmAnimation"
import { useQuery } from "@tanstack/react-query"
import { getHomepageData, getHowWeOperate } from "./api/apiCalls"
import Loading from "../../components/common/Loading"
import Hero from "./components/Hero"
import SoftwareSolutions from "./components/SoftwareSolutions"
import SoftwareComparison from "./components/SoftwareComparison"
import ProjectSelection from "./components/ProjectSelection"
import Customers from "./components/Customers"
import ProcessSection from "../../components/common/ProcessSection"
import BaseRevealText from "../../components/general/BaseRevealText"
import { Quote } from "lucide-react"
import { baseQuoteParseOptions } from "../../components/general/BaseQuote"
import ContactCTA from "../../components/common/ContactCTA"
import { getAllSolutionsPreviewCards } from "../SolutionDetail/api/apiCalls"

export type HomepageType = {
    loadingFunc: () => void
    scrollPositionY: number
}

export type AboutType = {}

export default function Homepage(props: HomepageType) {
  
    const { data, isLoading: newHomeDataLoading } = useQuery({
        queryKey: ["homepageNew"],
        queryFn: getHomepageData,
    })

    const { data: howWeOperate, isLoading: howWeOperateLoading } = useQuery({
        queryKey: ["howWeOperate"],
        queryFn: () => getHowWeOperate(),
    })

    const { data: solutionPreviewCards, isLoading: solutionPreviewCardsLoading } = useQuery({
        queryKey: ["solutionPreviewCards"],
        queryFn: getAllSolutionsPreviewCards,
    })


    if (newHomeDataLoading || howWeOperateLoading || !data || !howWeOperate) {
        return <Loading />
    }




    return (
        <BasePage>
            <Hero data={data.hero} />
            <SoftwareSolutions data={data.solutions} previewCards={solutionPreviewCards} />
            <SoftwareComparison softwareComparisonTransparent={data.softwareComparisonTransparent} leftSide={data.leftSide} rightSide={data.rightSide} />
            <ProcessSection
                heading={data.headingProcess}
                steps={howWeOperate}
            />
            <HelloFilmAnimation />
            <div className="md:h-[1400px]" />
            <ProjectSelection
                heading={data.projectSelection?.heading}
                projects={(data.projects?.data ?? [])
                    .filter((item: any) => item.attributes.preview)
                    .map((item: any) => ({
                        ...item.attributes.preview,
                        id: item.id,
                        previewImage: item.attributes.previewImage,
                        screenshot: item.attributes.screenshot,
                        hasDetailPage: item.attributes.hasDetailPage,
                    }))}
            />

            <Customers logos={data.customers?.logos} heading={data.customers?.heading} />

            <BaseRevealText
                text={data.quote}
                parseOptions={baseQuoteParseOptions}
                topContent={<Quote className="text-secondary opacity-20 -mb-24" size={200} strokeWidth={0.5} />}
            />

            <ContactCTA />
        </BasePage>
    )
}
